import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89c68114"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-list" }
const _hoisted_2 = { class: "brand-list-center" }
const _hoisted_3 = { class: "brand-list-search" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_6 = { class: "brand-list-box" }
const _hoisted_7 = { class: "brand-list-item-img" }
const _hoisted_8 = { class: "brand-list-item-name" }
const _hoisted_9 = { class: "brand-list-item-des" }
const _hoisted_10 = { class: "brand-list-item-tags" }

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue';
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type';
import { useRouter } from 'vue-router';
import Bottom from '../components/bottom.vue';
import { ArrowDownBold } from '@element-plus/icons-vue';

interface CompanyArea {
  id: string;
  name: string;
}

interface ActivityTag {
  id: string;
  name: string;
  type: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeNames = ref(['1']);
const handleChange = (val: string[]) => {
  console.log(val);
};

const ustore = useStore();
const loading = ref(true);
const searchItemSize = ref(10);

const statusType = ref(['', 'status1', 'status2', 'status3', 'status4']);

const allCompanyArea: CompanyArea = {
  id: 'all',
  name: '全部',
};
const allActivityTag: ActivityTag = {
  id: 'all',
  name: '全部',
  type: 7,
};

const handleToDetail = (item: any) => {
  router.push('/frontDesk/bbsDetail/' + item.id);
};

const companyAreaList: CompanyArea[] = [];
const activityTagList: ActivityTag[] = [];

const companyAreaSearch = ref(['全部']);
const activityTagSearch = ref(['全部']);

const bindData = reactive({
  companyAreaMax: 10,
  activityTagMax: 10,
  companyAreaList: companyAreaList,
  activityTagList: activityTagList,
  companyAreaTotalCount: 0,
  activityTagTotalCount: 0,
  newsPageParams: {
    curPage: 1,
    pageSize: 5,
    filtrate: {
      type: 2,
      industrys:'',
      activityTagIds: '',
      companyAreaIds: '',
      keyword: '',
    },
  },
  newsPageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
});

const companyAreaMoreEvent = () => {
  bindData.companyAreaMax =
    bindData.companyAreaMax < bindData.companyAreaTotalCount + 1
      ? bindData.companyAreaMax + searchItemSize.value
      : bindData.companyAreaMax;
  if (bindData.companyAreaMax > bindData.companyAreaTotalCount + 1) {
    bindData.companyAreaMax = bindData.companyAreaTotalCount + 1;
  }
};

const activityTagMoreEvent = () => {
  bindData.activityTagMax =
    bindData.activityTagMax < bindData.activityTagTotalCount + 1
      ? bindData.activityTagMax + searchItemSize.value
      : bindData.activityTagMax;
  if (bindData.activityTagMax > bindData.activityTagTotalCount + 1) {
    bindData.activityTagMax = bindData.activityTagTotalCount + 1;
  }
};

store.dispatch('frontBrandModule/listCompanyArea', {}).then(
  (data) => {
    //成功
    bindData.companyAreaMax =
      data.totalCount < searchItemSize.value
        ? data.totalCount + 1
        : searchItemSize.value;
    bindData.companyAreaList = data.result;
    bindData.companyAreaTotalCount = data.totalCount;
    bindData.companyAreaList.unshift(allCompanyArea);
  },
  (error) => {
    console.log(error.msg);
  }
);

var pageParams = {
    curPage: 1,
    pageSize: 20,
    filtrate: {
      type: 8 ,
      parentId: 'ROOT',
      keyword: '',
    },
  };
  store.dispatch('frontBrandModule/listBrandCategory', pageParams).then(
    (data) => {
      console.log(data);
        //成功
        bindData.activityTagMax =
          data.totalCount < searchItemSize.value
            ? data.totalCount + 1
            : searchItemSize.value;
        bindData.activityTagList = data.result;
        bindData.activityTagTotalCount = data.totalCount;
        bindData.activityTagList.unshift(allActivityTag);
    },
    (error) => {
      console.log(error.msg);
    }
  );

const remainCount = ref(0);

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  const companyAreaArray = companyAreaSearch.value.filter(
    (tag) => tag !== '全部'
  );
  const activityTagArray = activityTagSearch.value.filter(
    (tag) => tag !== '全部'
  );
  bindData.newsPageParams.filtrate.companyAreaIds = companyAreaArray.join(',');
  bindData.newsPageParams.filtrate.industrys = bindData.activityTagList
    .filter((tag) => activityTagArray.includes(tag.name))
    .map((tag) => tag.name)
    .join(',');
  store
    .dispatch('frontBrandModule/pageCompanyBrandList', bindData.newsPageParams)
    .then(
      (data) => {
        //成功
        if (isAppend) {
          data.result = bindData.newsPageResult.result.concat(data.result);
        }
        bindData.newsPageResult = data;
        remainCount.value =
          data.totalCount - bindData.newsPageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent(false);

const reloadSearchEvent = () => {
  bindData.newsPageParams.curPage = 1;
  bindData.newsPageParams.pageSize = 5;
  if (bindData.newsPageParams.filtrate.companyAreaIds.length == 0) {
    if (companyAreaSearch.value.length > 1) {
      companyAreaSearch.value = companyAreaSearch.value.filter(
        (tag) => tag !== '全部'
      );
    }
  } else if (companyAreaSearch.value.includes('全部')) {
    companyAreaSearch.value = ['全部'];
  }
  if (bindData.newsPageParams.filtrate.activityTagIds.length == 0) {
    if (activityTagSearch.value.length > 1) {
      activityTagSearch.value = activityTagSearch.value.filter(
        (tag) => tag !== '全部'
      );
    }
  } else if (activityTagSearch.value.includes('全部')) {
    activityTagSearch.value = ['全部'];
  }
  searchEvent(false);
};

const loadPageDataEvent = () => {
  if (
    bindData.newsPageParams.curPage * bindData.newsPageParams.pageSize <
    bindData.newsPageResult.totalCount
  ) {
    bindData.newsPageParams.curPage = bindData.newsPageParams.curPage + 1;
    searchEvent(true);
  }
};



return (_ctx: any,_cache: any) => {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_collapse, {
            class: "brand-list-search-hd",
            modelValue: activeNames.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeNames).value = $event)),
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                title: "筛选条件",
                name: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_container, { class: "brand-search-box" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, { "label-width": "100px" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "行业：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: activityTagSearch.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activityTagSearch).value = $event)),
                                size: "large",
                                onChange: reloadSearchEvent
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityTagList.slice(
                          0,
                          _unref(bindData).activityTagMax
                        ), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                      key: item.id,
                                      label: item.name
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128)),
                                  (
                          _unref(bindData).activityTagTotalCount + 1 >
                            searchItemSize.value &&
                          _unref(bindData).activityTagMax <
                            _unref(bindData).activityTagTotalCount + 1
                        )
                                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                                        key: 0,
                                        class: "bbs-search-more",
                                        type: "text",
                                        size: "large",
                                        onClick: activityTagMoreEvent
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_4,
                                          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ArrowDownBold))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "地区：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: companyAreaSearch.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((companyAreaSearch).value = $event)),
                                size: "large",
                                onChange: reloadSearchEvent
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).companyAreaList.slice(
                          0,
                          _unref(bindData).companyAreaMax
                        ), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                      key: item.id,
                                      label: item.name
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128)),
                                  (
                          _unref(bindData).companyAreaTotalCount + 1 >
                            searchItemSize.value &&
                          _unref(bindData).companyAreaMax <
                            _unref(bindData).companyAreaTotalCount + 1
                        )
                                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                                        key: 0,
                                        class: "bbs-search-more",
                                        type: "text",
                                        size: "large",
                                        onClick: companyAreaMoreEvent
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_5,
                                          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ArrowDownBold))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).newsPageResult.result, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "brand-list-item",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_image, {
                  src: item.brandBigLogoFullPath
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.brandName), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.companyFace), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.industry) + "|" + _toDisplayString(item.businessCategory), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})